export default function verifyDashboard({ next, store, router }) {
  if (process.env.VUE_APP_SHOW_DASHBOARD == 'false') {
    router.push({ name: 'servers.compute' })
  }
  return next()
}
